import React, { useState, useEffect, useRef } from 'react'
import { Input, Button, Form } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { CloseIco, RequireSign } from '../../../../modules/CustomIcons'

import './index.scss'
import '../ColumnSearchProps/index.scss'
import { removeEmojiCodes } from '../../../services/helper'

const SearchableColumn: React.FC<any> = (props) => {
  const [search, toggleSearch] = useState(false)
  const [isEditing, setEditing] = useState(false)
  const [onFocus, setOnFocus] = useState(false)
  const [value, setValue] = useState(props.value || '')

  const inputRef = useRef<Input>(null)
  const [form] = Form.useForm()

  useEffect(() => {
    if (inputRef.current) {
      // console.log(inputRef.current)
      inputRef.current!.focus()
    }

    updateValue(props.value || '')
  }, [isEditing, props.value])

  const updateValue = (value: any) => {

    if (props.form) {

      props.form.setFieldsValue({
        [props.name]: removeEmojiCodes(value),
      })
    }

    if (inputRef.current) {
      inputRef.current!.focus()
    }

    setValue((old_data: any) => value)
  }

  const handleSearch = (e) => {

    updateValue(e.target.value)

    if (props.onChange) {
      props.onChange(e)
    }
  }
  const handleSearchClick = () => {
    handleRemove()
    toggleSearch(true)
    if(props.filter && props.filter === 'searchfilter'){
      setEditing(true)
    }

  }
  const handleRemove = () => {
    if(props.nickname){
      if (props.onChange) {
        const val = {
          target: {
            value: '',
          },
        }
        props.onChange(val)
      }
    }else{
      updateValue('')
      if (props.onChange) {
        const val = {
          target: {
            value: '',
          },
        }
        props.onChange(val)
      }
    }
   
  }

  const handleBlur = (e: any) => {

    if (props.filter && props.filter === 'searchfilter') {
      if (!value) {
        setEditing(false)
        toggleSearch(false)
        setOnFocus(false)
        if (props.onBlur) {
          props.onBlur(e)

        }
        else {

          updateValue('')
        }
      }
    }
    else {
      toggleSearch(false)
      setEditing(false)
      setOnFocus(false)

      if (props.onBlur) {
        props.onBlur(e)
      } else {
        updateValue('')
      }
    }

  }

  const handleKeyup = (e) => {
    if (props.onKeyUp) {
      props.onKeyUp(e)
    }

    //updateValue(e.target.value)
  }

  const handleFocus = () => {
    setOnFocus((old_data) => true)
  }

  let div_class = search ? 'column-header flex bordered' : 'column-header flex'

  useEffect(() => {
    if (props?.buttonClicked !== undefined && props?.buttonClicked !== 0) {
      TriggeredFunc()
    }
  }, [props?.buttonClicked])

  const TriggeredFunc = () => {

    if (props?.page === "salaryList") {
      toggleSearch(false)
      setEditing(false)
      setOnFocus(false)
    } else {
      handleRemove()
      toggleSearch(false)
      setEditing(false)
      setOnFocus(false)
    }

  }

  return (
    <div className={`${div_class} ${props?.divClass}`}>
      {search || props.showSearch ? (
        <div className={`column-header__search`}>
          <Form.Item
            name={props.name || ''}
            label={props.labelItem}
            labelCol={props.labelCol}
            wrapperCol={props.wrapperCol}
            validateTrigger={['onChange', 'onBlur']}
            style={{ padding: '0px' }}
            className={`input-field ant-table-column-title search-column ${props.large ? 'large-column' : props.medium  ? 'medium-column' : ''
              }  ${props.className ? props.className : ''}`}
          >
            <Input
              placeholder={props.placeholder || ''}
              ref={inputRef}
              onChange={handleSearch}
              onFocus={handleFocus}
              allowClear={props.allowClear}
              onKeyDown={props.handleKeyDown}
              onBlur={handleBlur}
              onKeyUp={handleKeyup}
              maxLength={props.maxLength || 160}
              style={{ paddingLeft: 0 }}
              className={`not-required column-header__input ${props?.className}`}
              required={false}
              name={props.name || ''}
              autoFocus={false}
            />
          </Form.Item>
        </div>
       ) : (
         <div
          onClick={handleSearchClick}
          className={`ant-table-column-title flex ${props.large ? 'large-column' : props.medium  ? 'medium-column' : ''
            }  ${props.className ? props.className : ''}`}
        >
          <p
            className={` not_open_popup other_color ${props.required ? 'required-column' : ''
              }`}
          >
            {props.title}
          </p>
        </div>
      )}
      {!value ? (
        <Button
          ghost
          className="transparent search-icon"
          onClick={handleSearchClick}
          icon={props.customIcon ? props.customIcon : <SearchOutlined />}
        />
      ) : (
        !props.allowClear && (
          <Button
            ghost
            className="clear-icon custom-close"
            onClick={handleRemove}
            icon={<CloseIco />}
          />
        )
      )}
    </div>
  )
}
export default SearchableColumn
